import { useQuery } from '@tanstack/react-query';
import { getHotPlayers } from '../api';
import PageHeader from '../components/PageHeader';

export default function HotPlayers() {
  const { data, isLoading } = useQuery({
    queryKey: ['hot-players'],
    queryFn: getHotPlayers,
    refetchInterval: 60_000,
  });

  return (
    <>
      <PageHeader
        title="Hottest players"
        subtitle="Top performers ranked by goals + assists once matches begin."
      />
      <div className="px-4 lg:px-0">
        {isLoading ? (
          <div className="card p-6 text-center text-dim">Loading…</div>
        ) : (data?.players?.length ?? 0) === 0 ? (
          <div className="card p-8 text-center space-y-2">
            <div className="text-3xl">⚽</div>
            <div className="text-sm font-semibold">No matches played yet</div>
            <div className="text-xs text-dim max-w-sm mx-auto">
              {data?.note ?? 'Live player rankings unlock once the tournament begins.'}
            </div>
          </div>
        ) : (
          <div className="card overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-[10px] uppercase tracking-wider text-dim border-b border-ink-800">
                  <th className="text-left py-2 px-3 font-medium w-8">#</th>
                  <th className="text-left font-medium">Player</th>
                  <th className="text-right font-medium pr-3 w-16">Score</th>
                </tr>
              </thead>
              <tbody>
                {data!.players.map((p, i) => (
                  <tr key={p.id} className="border-b border-ink-800/40 last:border-0">
                    <td className="py-2 px-3 stat text-dim">{i + 1}</td>
                    <td className="py-2">
                      <div className="text-sm">{p.name}</div>
                      <div className="text-[10px] text-dim">{p.team}</div>
                    </td>
                    <td className="text-right pr-3 stat text-pitch-400">{p.score.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
